import { Edge, Node } from 'reactflow'

import { SetEdgesType, SetNodesType } from '@ui/stores/pipelinesWorkflow/NodeAndEdgeStore'

import { createNewEdges } from './createNewEdges'
import { getClosestNode } from './getClosestNode'
import { getDraggedChildNode } from './getDraggedChildNode'
import { getParent } from './getParent'
import { getRelationType } from './getRelationType'

export const onNodeDragStop = (
  targetNode: Node,
  nodes: Node[],
  edges: Edge[],
  setNodes: (nodes: SetNodesType) => void,
  setEdges: (edges: SetEdgesType) => void,
  refreshLayout: (refresh: boolean) => void
) => {
  // Have we been injected between two nodes?
  const newChild = getDraggedChildNode(targetNode, nodes, edges)

  // Get our parent
  const parent = getParent(targetNode, nodes, edges)

  // Get the node we are closest to, and what kind of relationship we have
  const closestNode = getClosestNode(targetNode, nodes)
  const relationType = getRelationType(targetNode, closestNode)
  // Get the parent of the node we are closest to
  const closeNodeParent = getParent(closestNode, nodes, edges)

  // Generate the appropriate edges
  const newEdgesByProximity = createNewEdges(targetNode, closestNode, relationType, closeNodeParent) || []

  setNodes((nodes: Node[]) => {
    return nodes.map((node) => {
      if (node.id === targetNode.id) {
        const ogType = node.data.ogtype
        if (ogType) {
          node.type = ogType
        }
        node.data = { ...node.data, modified: true, parentSliceId: parent?.id }
      }

      // We want to remap any parent child relationships that were modified.
      if (node.id === newChild?.id) {
        node.data = { ...node.data, modified: true, parentSliceId: targetNode.id }
      }

      return node
    })
  })

  // turn the temporary edges into real edges
  // and remove any edges that are still temporary
  setEdges((edges: Edge[]) => {
    return edges
      .map((edge) => {
        if (newEdgesByProximity.length > 0 && edge.type === 'drag') {
          edge.type = 'span'
          edge.animated = false

          return { ...edge }
        } else {
          return edge
        }
      })
      .filter((edge) => edge.className !== 'hidden-during-drag')
  })

  // There's only one edge in proximity we need to create a placeholder node
  // if (newEdgesByProximity.length === 1 && newEdgesByProximity[0].type === 'span') {
  //   createPlaceholderNode({ currentNodeId: targetNode.id, placeHolderNodeId: uuid(), undeletable: true })
  // }

  refreshLayout(true)
}
